export enum LobbyAction {
  RETRY_CALL = 'can_retry_call',
  SCHEDULE = 'can_schedule',
  REQUEST_CONTACT = 'can_request_contact'
}
